import { IRedactedMember } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorUserLegalName } from "./selectorUserLegalName";

export const selectorMemberLegalBusinessName = (member: IRedactedMember) =>
  member.profile?.company?.legalBusinessName ||
  selectorUserLegalName(member.user);
